import React, { forwardRef } from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
const FormBuilderFormInterfaceButton = forwardRef(({ item, disabled, t, buttonType, onClick }, ref) => {
  if (!item) return null;
  const { button } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  return /* @__PURE__ */ React.createElement("div", { className: item.class }, /* @__PURE__ */ React.createElement("button", { type: buttonType, disabled, onClick, ref }, t(button == null ? void 0 : button.nodeValue)));
});
FormBuilderFormInterfaceButton.displayName = "FormBuilderFormInterfaceButton";
export default React.memo(FormBuilderFormInterfaceButton);
